function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".anchor_stroke{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "anchor"
}, /*#__PURE__*/React.createElement("line", {
  className: "anchor_stroke",
  x1: 15.78,
  y1: 38,
  x2: 15.78,
  y2: 7
}), /*#__PURE__*/React.createElement("line", {
  className: "anchor_stroke",
  x1: 10.78,
  y1: 14,
  x2: 20.78,
  y2: 14
}), /*#__PURE__*/React.createElement("circle", {
  className: "anchor_stroke",
  cx: 15.78,
  cy: 4,
  r: 3
}), /*#__PURE__*/React.createElement("path", {
  className: "anchor_stroke",
  d: "M1,30.12v-4c2.4,5.8,8.11,9.88,14.78,9.88s12.38-4.08,14.78-9.88v4"
}));

var SvgAnchor = function SvgAnchor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "anchorIcon",
    viewBox: "-2 -2 35.56 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnchor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/anchor.55c8973e.svg";
export { ForwardRef as ReactComponent };